// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserAudit_wrapper__3JjpU","table_container":"UserAudit_table_container__1nOGa","user_table":"UserAudit_user_table__3dv9P"};